import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Dropdown } from 'react-bootstrap';
import { handleAPIError, handleCatchError } from 'utils/handleErrors';
import RepsCSV from '../../../../components/reactCsv/RepsCSV';
// api
import { getDocuments } from '../../../../api/Api-user';
// components
import LoadingPulse from '../../../../components/loading/LoadingPulse';
import RowBilling from './card/RowBilling';
import CardBilling from './card/CardBilling';
import Paginate from '../../../../components/Paginate';

const Reps = () => {
  const [reps, setReps] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  // paginate
  const [totalPages, setTotalPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [changePage, setChangePage] = useState(1); // para la peticion
  const [changeItemsNum, setChangeItemsNum] = useState(10); // para la peticion
  const [message, setMessage] = useState('');

  // - Use references to do scroll Up
  const startRef = useRef(null);
  const settingPage = (limit) => {
    setChangeItemsNum(limit);
    setChangePage(1);
  };

  const handleGetReps = async () => {
    if (reps) {
      setIsLoading(true);
    }
    try {
      const response = await getDocuments('reps', changePage, changeItemsNum);
      if (response.data !== undefined) {
        setReps(response.data);
        setCurrentPage(response.current_page); // para actualizar la vista
        setPageSize(response.page_size); // para actualizar la vista
        setTotalPages(response.total_pages);
        if (startRef.current) {
          startRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        if (response.data.length === 0) {
          setMessage('No tienes Reps (comprobantes de pago) registrados.');
        }
      } else if (response.error) {
        setReps(reps || []);
        setTotalPages(0);
        handleAPIError(response);
      }
    } catch (error) {
      setReps(reps || []);
      handleCatchError(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    handleGetReps();
  }, [changePage, changeItemsNum]);

  return (
    <>
      {isLoading && <LoadingPulse />}
      {reps?.length === 0 && message ? (
        <div className="pt-5 mt-5">
          <h3 className="text-center mt-5 pt-5">
            {message}
            <img alt="box" src="/img/animation/doc.webp" style={{ width: '50px', height: '50px' }} />{' '}
          </h3>
        </div>
      ) : (
        <div ref={startRef} id="cardContainer">
          <Row className="g-0">
            <Col className="mb-3 text-end">
              {/* Excel Buttons  */}
              {reps?.length > 0 && <RepsCSV reps={reps} />}
              {/* Dropdown  */}
              <Dropdown align={{ xs: 'end' }} className={`d-inline-block ms-1 ${reps?.length < 10 && 'd-none'}`}>
                <Dropdown.Toggle variant="foreground-alternate" className="shadow sw-13">
                  {`${pageSize} Reps`}
                </Dropdown.Toggle>
                <Dropdown.Menu className="shadow dropdown-menu-end">
                  <Dropdown.Item className={`${pageSize === 10 && 'd-none'}`} onClick={() => settingPage(10)}>
                    10 Reps
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 20 && 'd-none'}`} onClick={() => settingPage(20)}>
                    20 Reps
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 50 && 'd-none'}`} onClick={() => settingPage(50)}>
                    50 Reps
                  </Dropdown.Item>
                  <Dropdown.Item className={`${pageSize === 100 && 'd-none'}`} onClick={() => settingPage(100)}>
                    100 Reps
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className={`${reps?.length < 2 && 'd-none'} mt-3 text-muted`}>{`Página ${currentPage}`}</div>
              {/* Length End */}
            </Col>
          </Row>
          {/* List Header Start */}
          <RowBilling />
          {/* List Header End */}
          {/* List Items Start */}
          {reps?.map((rep, index) => (
            <CardBilling data={rep} doc="rep" key={index} />
          ))}
          {/* List Items End */}
          {/* Pagination Start */}
          <div className={`d-flex flex-column justify-content-center align-items-center mt-5 mx-auto ${totalPages < 2 && 'd-none'}`}>
            <Paginate currentPage={currentPage} totalPages={totalPages} setCurrentPage={setChangePage} />
          </div>
          {/* Pagination End */}
        </div>
      )}
    </>
  );
};

export default Reps;
